module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-21-2d4d846df949c5ebd91a5d98b17a9fbf.svg";